import type { PropsWithChildren } from "react";
import { getHomepageUrl } from "src/services/configService";
import { makeStyles } from "tss-react/mui";

import { PageContainer } from "@dashboard/shared/components/PageContainer";
import { Box } from "@mui/material";
import ApmLink from "@shared/ApmLink";
import { Logo } from "@shared/Logo/Logo";

const useStyles = makeStyles()((theme) => ({
    logoLink: {
        marginBottom: theme.spacing(16),
        display: "inline",
    },
    logoContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    content: {
        width: "100%",
        maxWidth: 400,
        margin: "0 auto",
    },
}));

export const AuthFlowContainer = ({ children }: PropsWithChildren) => {
    const { classes } = useStyles();

    return (
        <PageContainer fullWidth={false} scrollable>
            <Box className={classes.logoContainer}>
                <ApmLink href={getHomepageUrl()} className={classes.logoLink}>
                    <Logo variant="full" />
                </ApmLink>
            </Box>
            <Box className={classes.content}>{children}</Box>
        </PageContainer>
    );
};
